module.exports = __webpack_public_path__ + "img/copy_icon.894f2943.svg";